// Pure model of the Vue login page (src/components/login), rebuilt over the legacy login page
// (public/m.eagle/app/pages/login/login.js + login.htm). Nothing here touches window, document or the iframe.

// login.htm panels, switched by login.js with jQuery show / hide / slide. The legacy decides some of them
// itself (the reset form for __rp=1, the expired password form on ERR-0096), so the Vue page shows the one
// the legacy displays. Mid-slide both panels can be visible (the target, listed first, wins), or none
// (Main.js slideIn / slideOut fade the next one in 500ms later): null, the shown panel stays.
export const LOGIN_PANELS = [
	{ name: 'expired', selector: '.password-expired-container' },
	{ name: 'reset', selector: '.reset-password-container' },
	{ name: 'forgotten', selector: '.password-forgotten-login-container' },
	{ name: 'main', selector: '.main-login-container' },
];

export function visibleLoginPanel(visibility = {}) {
	return LOGIN_PANELS.find(({ name }) => visibility[name])?.name ?? null;
}

// login.htm language switch (localStorage.loginLocale, read by Globalization.js and src/i18n/bootstrap.js).
// Shown by their own names, like most language pickers: no translation key needed.
export const LOGIN_LANGUAGES = [
	{ locale: 'fr-FR', label: 'Français' },
	{ locale: 'en-GB', label: 'English' },
	{ locale: 'es-ES', label: 'Español' },
	{ locale: 'pt-PT', label: 'Português' },
	{ locale: 'nl-NL', label: 'Nederlands' },
	{ locale: 'de-DE', label: 'Deutsch' },
];

export const languageFlag = (locale) => `/m.eagle/img/flags/${locale}.png`;

// mdcControl.js uppercases the user name and customer code fields on every key stroke.
export const loginCode = (value) => String(value ?? '').toUpperCase();

// The required fields of each form (mdcControl.js disables the form button until they are filled);
// login.js resetHandler() also runs the browser validity of its email field.
const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const filled = (value) => String(value ?? '').trim().length > 0;

export const canSubmitLogin = ({ userName, password, customerCode } = {}) => [userName, password, customerCode].every(filled);
export const canRequestReset = ({ email, customer } = {}) => EMAIL.test(String(email ?? '').trim()) && filled(customer);
export const canChangePassword = ({ email, customer, key, password, confirm } = {}) => [email, customer, key, password, confirm].every(filled);
export const canUpdateExpiredPassword = ({ oldPassword, newPassword } = {}) => [oldPassword, newPassword].every(filled);
